export const black = {
  100: '#000000'
};

export const grey = {
  100: '#4B4B4B',
  200: '#ecf0f1'
};

export const white = {
  100: '#FFFFFF'
};
